/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { Element, scroller } from 'react-scroll'

import { useDebounce } from '@hooks/useDebounce'
import { useAuthentication } from '@hooks/useAuthentication'
import { useUserReadingAction } from '@hooks/userReading/useUserReadingAction'
import { VerticalStyleProps, WithVerticalStyleProps } from './interface'

export function withVerticalStyle(Component: React.FC<VerticalStyleProps>) {
  function WithVerticalStyle({
    chapterPages,
    continuePageId,
    isReview = false,
  }: WithVerticalStyleProps) {
    const userReadingClient = useUserReadingAction()
    const { isAuthenticated } = useAuthentication()
    const { debounce } = useDebounce()

    function createUserReadingHandler(chapterPageId: number) {
      if (isAuthenticated && !isReview) {
        debounce(() => {
          userReadingClient.createUserReading(chapterPageId)
        }, 400)
      }
    }

    useEffect(() => {
      if (continuePageId) {
        scroller.scrollTo(continuePageId.toString(), {
          smooth: true,
          offset: -160,
        })
      }
    }, [continuePageId])

    const newProps = {
      Element,
      chapterPages,
      createUserReadingHandler,
    }
    return <Component {...newProps} />
  }
  return WithVerticalStyle
}
